import { Outlet } from "react-router-dom";
import NavigationPanel from "../components/NavigationPanel";
import NavigationMenu from "../components/NavigationMenu";
import ContentLoading from "../components/ContentLoading";
import { useCallback, useEffect, useState } from "react";
import { getProfile } from "../repository/auth.repository";
import { retry } from "../utils/http";
import { useGuard } from "../Guard";
import { useDispatch } from "../store/store";
import { authorizeActions } from "../store/authorize";
import { Col, Layout, Row, theme } from "antd";

function MasterPage() {
  const { token } = theme.useToken();
  const guard = useGuard();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [tryLogout, setTryLogout] = useState(false);
  const [selectedMainMenu, setSelectedMainMenu] = useState<string>();

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    // Fetch the profile immediately (retry handles a cold/slow backend + the tryLogout escalation);
    // the app shell shows as soon as it resolves — no artificial splash delay.
    retry((count) => {
      if (!tryLogout) {
        setTryLogout(count > 2);
      }
      return getProfile();
    }).then((user) => {
      if (cancelled) return;
      setLoading(false);
      setTryLogout(false);
      dispatch(authorizeActions.setUser(user));
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleMainMenuSelect = useCallback((key: string) => {
    setSelectedMainMenu(key);
  }, []);

  return (
    <ContentLoading
      loading={loading}
      logo
      nointernet={guard.nointernet}
      tryLogout={tryLogout}
      title="Preparing your workspace…"
    >
      <Layout className="flex flex-auto flex-col overflow-hidden">
        {/* Navigation */}
        <Col className="flex flex-col">
          <NavigationPanel onMenuSelect={handleMainMenuSelect} />
        </Col>
        {/* Content */}
        <Row className="flex flex-1 flex-row flex-nowrap overflow-hidden">
          <NavigationMenu selectedMainMenu={selectedMainMenu} />
          <Col className="flex flex-auto flex-col overflow-hidden p-2 pl-0 pt-0">
            <Col
              className="flex flex-auto flex-col overflow-hidden shadow-sm"
              style={{
                backgroundColor: token.colorBgContainer,
                borderRadius: token.borderRadius,
              }}
            >
              <Outlet />
            </Col>
          </Col>
        </Row>
      </Layout>
    </ContentLoading>
  );
}

export default MasterPage;
